import React, { useState } from "react";
import logocomodosecure from "./images/logo-comodo-secure.png";
import logomemberFDIC from "./images/logo-member-FDIC.png";
import NeedHelp from "./NeedHelp";
import {linkTrackEvent} from "../services/analyticsService";

function openComodoVerify() {
  var url =
    "https://www.trustlogo.com/ttb_searcher/trustlogo?v_querytype=W&v_shortname=SC4&v_search=enrollhsa.optumbank.com&x=6&y=5";
  window.open(url, "Comodo Secure", "width=443,height=550");
  return false;
}

function Footer() {

    const [isBannerHidden, setIsBannerHidden] = useState(window.sessionStorage.getItem("cookieBannerHidden")==="true");
    return (
        <>
            <NeedHelp/>
            <footer className="page-footer">
                <div className="footer-copyright">
                    © {new Date().getFullYear()} Optum Bank. All Rights Reserved.
                </div>
                <ul className="footer-links">
                    <li>
                        <a
                            href="https://www.optum.com/en/privacy-policy.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => {
                                let link = e.currentTarget.href || "";
                                linkTrackEvent("privacy and security", "open hsa form", "external", link)
                            }}
                        >
                            Privacy & Security
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.optum.com/en/terms-of-use.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => {
                                let link = e.currentTarget.href || "";
                                linkTrackEvent("terms of use", "open hsa form", "external", link)
                            }}
                        >
                            Terms of Use
                        </a>
                    </li>
                </ul>
                <ul className="footer-certifications">
                    <li className="fdic">
                        <img src={logomemberFDIC} alt="Member FDIC"/>
                    </li>
                    <li className="comodo">
                        {/* eslint-disable-next-line */}
                        <a onClick={openComodoVerify} data-testid="link-element">
                            <img alt="Comodo Secure" src={logocomodosecure}/>
                        </a>
                        {/* disabled since href is not being used (causing lint warning) but the navigation is handled by the onClick function */}
                    </li>
                </ul>
            </footer>
            <div className="o5-legal-banner">

                <div
                    className={`o5-legal-banner-container${isBannerHidden ? " o5-legal-banner-container--hidden" : ""}`}
                    id="o5-legal-banner-container">
                    <div className="o5-legal-banner-container__region dmp-container"
                         role="region"
                         aria-labelledby="o5-legal-banner-container-label">
                        <button className="o5-legal-banner-container__close"
                                type="button"
                                aria-label="Close Data Use Notice"
                                onClick={() => {
                                    setIsBannerHidden(true);
                                    window.sessionStorage.setItem("cookieBannerHidden", "true");
                                }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                 fill="none"
                                 focusable="false" aria-hidden="true">
                                <path
                                    d="M18.3004 5.70039C17.9004 5.30039 17.3004 5.30039 16.9004 5.70039L12.0004 10.6004L7.10039 5.70039C6.70039 5.30039 6.10039 5.30039 5.70039 5.70039C5.30039 6.10039 5.30039 6.70039 5.70039 7.10039L10.6004 12.0004L5.70039 16.9004C5.30039 17.3004 5.30039 17.9004 5.70039 18.3004C6.10039 18.7004 6.70039 18.7004 7.10039 18.3004L12.0004 13.4004L16.9004 18.3004C17.3004 18.7004 17.9004 18.7004 18.3004 18.3004C18.7004 17.9004 18.7004 17.3004 18.3004 16.9004L13.4004 12.0004L18.3004 7.10039C18.7004 6.70039 18.7004 6.10039 18.3004 5.70039Z"
                                    fill="currentColor"></path>
                            </svg>
                        </button>
                        <div className="o5-legal-banner-container__content">
            <span className="o5-legal-banner-container__icon"
                  aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     focusable="false" aria-hidden="true">
                    <path
                        d="M14.4 6L14.2 4.8C14.1 4.3 13.7 4 13.2 4H6C5.4 4 5 4.4 5 5V20C5 20.5 5.4 21 6 21C6.6 21 7 20.5 7 20V14H12.6L12.8 15.2C12.9 15.7 13.3 16 13.8 16H19C19.5 16 20 15.6 20 15V7C20 6.4 19.5 6 19 6H14.4Z"
                        fill="currentColor"></path>
                </svg>
            </span>
                            <div className="o5-legal-banner-container__text">

                                <p className="o5-legal-banner-container__label"
                                   id="o5-legal-banner-container-label"><strong>Data use</strong></p>


                                <p className="o5-legal-banner-container__body">
                                    We use cookies and similar tools to make your use of this website easy and to keep
                                    it working
                                    properly. We may share data about you and how you use the site with third parties,
                                    such as analytics
                                    and marketing partners. Learn more in our <a
                                    href="https://www.optum.com/en/privacy-policy.html">
                                    <strong>Privacy Policy</strong>
                                </a> and <a href="https://www.optum.com/en/terms-of-use.html">
                                    <strong>Terms of Use</strong></a>. By continuing to use the site, you agree to this.
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Footer;
